<script setup lang="ts">
import { defineEmits } from "vue";
import imageTemplate from "@/assets/icons/image-template.svg";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["image:select"]);
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center justify-center max-w-[292px]">
    <img :src="imageTemplate" alt="image-template" class="w-40 h-52 mb-10" />
    <GradientButton
      class="w-[289px] min-h-14 mb-2"
      bg-color="bg-brown-gradient"
      hover-bg-color="bg-orange-gradient"
      :text="t('calculators.apartment-plan.actions.file-select-alternative')"
      @click="emit('image:select')"
    />
    <p class="text-sm text-muted text-center">
      {{ t("calculators.apartment-plan.actions.file-select-label") }}
    </p>
  </div>
</template>
